module.exports = __webpack_public_path__ + "img/figure02.bfa8b1e4.png";